export class MonitorTaskProductListData {
  totalProductsCount: number
  pageNumber: number
  pageSize: number
  products: PagedData[]
}

export interface PagedData {
  monitorTaskProductId: number
  productImageUrl: string
  productName: string
  lowPrice: number
  highPrice: number
  monitorPrice?: number
  monitorStatus: string
  productNotFound: boolean
  canMonitoringPrice: boolean
  hasAttachments: boolean
  aiMatchedProductUrl?: string
}
